import axios, {
  type AxiosError,
  type AxiosRequestConfig,
  type AxiosResponse,
} from 'axios';
import {
  blastDataToLogCannon,
  type LogResponse,
} from '@/utils/blastDataToLogCannon';
import { createAxiosConfig } from '@/utils/createAxiosConfig';

export const apiWrapper = async <T>(
  url: string,
  config?: AxiosRequestConfig,
): Promise<T> => {
  const axiosConfig = { ...createAxiosConfig(), ...config };
  const startTime = Date.now();
  const fullUrl = axiosConfig.params
    ? `${url}?${new URLSearchParams(axiosConfig.params as Record<string, string>)}`
    : url;

  try {
    const response: AxiosResponse<T> = await axios(url, axiosConfig);
    const endTime = Date.now();

    // Log successful request
    blastDataToLogCannon({
      ...axiosConfig.headers,
      url: fullUrl,
      method: axiosConfig.method,
      status: response.status,
      responseTime: endTime - startTime,
    });

    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    const endTime = Date.now();

    // Log failed request
    blastDataToLogCannon({
      ...axiosConfig.headers,
      response: axiosError.response
        ? (axiosError.response.data as LogResponse)
        : undefined,
      url: fullUrl,
      method: axiosConfig.method,
      status: axiosError.response
        ? axiosError.response.status
        : 'Network Error',
      responseTime: endTime - startTime,
      errorMessage: axiosError.message,
    });

    throw error;
  }
};
